import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CdkTableModule } from '@angular/cdk/table';
import { HeaderComponent } from '../shared/header.component';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { SessionNewComponent } from './session-new.component';
import { SessionPostsComponent } from './session-posts.component';
import { map, Observable, tap } from 'rxjs';
import { SessionDto } from '@oracychampions/api-interfaces';

@Component({
  selector: 'oc-session-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CdkTableModule,
    HeaderComponent,
    NgbNavModule,
    SessionNewComponent,
    SessionPostsComponent,
    RouterModule,
  ],
  template: `
    <div class="oc-session-dashboard">
      <ul ngbNav #nav="ngbNav" class="nav-pills">
        <li ngbNavItem>
          <button ngbNavLink>New Game</button>
          <ng-template ngbNavContent><oc-session-new [sessionId]="sessionId"></oc-session-new></ng-template>
        </li>
        <li ngbNavItem>
          <button ngbNavLink>History</button>
          <ng-template ngbNavContent><oc-session-posts></oc-session-posts></ng-template>
        </li>
        <li class="ms-auto">
          <button class="btn btn-outline-light" (click)="exit()">Exit</button>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>
  `,
  styles: `
    .oc-session-dashboard {
      padding: 3rem;
      background-color: #222;
      width: 100%;
      height: 100vh;
    }

    .nav-pills .nav-link {
      color: #eee;

      &.active {
        background-color: #eee;
        color: #222;
      }
    }

    ::ng-deep {
      label {
        color: #eee;
      }
    }
  `,
})
export class SessionDashboardComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  session$: Observable<SessionDto>;
  session: any;

  constructor() {
    this.session$ = this.route.parent!.data.pipe(
      map((data) => data['session']),
      tap((session) => (this.session = session)),
    );
    this.session$.subscribe();
  }

  get sessionId(): string {
    return this.route.parent!.snapshot.params['id'];
  }

  exit() {
    this.router.navigate(['group', this.session.groupId]);
  }
}
